import React from "react";
import { useSelector } from "react-redux"
import { NavLink, Outlet } from "react-router-dom";
import { getUser, getLoading } from "../../services/selectors";
import styles from "./profile.module.css";
import Loader from "../../components/loader/loader";


const Profile = () => {

  const user = useSelector(getUser);
  const isLoading = useSelector(getLoading);

  if (!user) return null;
  return (
    <main className="main">
      {isLoading ? <Loader /> : null}
      <h1 className='title'>
        Здравствуйте,<br /><span className="break_all">{user.first_name}.</span>
      </h1>
      <nav className={styles.nav}>
        <li>
          <NavLink end to='/profile/me'
            className={({ isActive }) => isActive ? styles.nav_item : styles.nav_item_inactive}
          >
            Мои данные
          </NavLink>
        </li>
        <li>
          <NavLink to='/profile/firms'
            className={({ isActive }) => isActive ? styles.nav_item : styles.nav_item_inactive}
          >
            Организации
          </NavLink>
        </li>

        <li>
          <NavLink end to='/profile/set_password'
            className={({ isActive }) => isActive ? styles.nav_item : styles.nav_item_inactive}
          >
            Смена пароля
          </NavLink>
        </li>
        <li>
          <NavLink end to='/profile/set_email'
            className={({ isActive }) => isActive ? styles.nav_item : styles.nav_item_inactive}
          >
            Смена почты
          </NavLink>
        </li>
        <li>
          <NavLink end to='/profile/delete'
            className={({ isActive }) => isActive ? styles.nav_item__red : styles.nav_item_inactive_red}
          >
            Удаление аккаунта
          </NavLink>
        </li>
      </nav>
      <div className={styles.container}>
        <Outlet />
      </div>
    </main>
  );
}

export default Profile;
